export class ReferenceDataOptionLists {
  public static readonly AccessControllerAutocompleteAgentType = 'AccessControllerAutocompleteAgentType';
  public static readonly AccountDistributedDocumentDetails = 'AccountDistributedDocumentDetails';
  public static readonly AccountDistributedDocumentType = 'AccountDistributedDocumentType';
  public static readonly AccountStatus = 'AccountStatus';
  public static readonly AccountStatusActive = 'Active';
  public static readonly AccountStatusOffline = 'Offline';
  public static readonly AccountStatusPending = 'Pending';
  public static readonly AccountStatusSuspended = 'Suspended';
  public static readonly AccountTypeForSwitchMatching = 'AccountTypeForSwitchMatching';
  public static readonly AccountantType = 'AccountantType';
  public static readonly AccountantTypeOther = 'Other';
  public static readonly AdviceAppStatuses = 'AdviceAppStatuses';
  public static readonly AdvisedFactFindStatuses = 'AdvisedFactFindStatuses';
  public static readonly AdvisedRecommendationStatuses = 'AdvisedRecommendationStatuses';
  public static readonly AdviceStatusNotification = 'AdviceStatusNotification';
  public static readonly AdvisedResidentialQuestions = 'AdvisedResidentialQuestions';
  public static readonly AdvisedStatus = 'AdvisedStatus';
  public static readonly AdvisedStatusAdviceNotProceeding = 'AdviceNotProceeding';
  public static readonly AdvisedStatusAwaitingCustomer = 'AwaitingCustomer';
  public static readonly AdvisedStatusFF1Complete = 'FF1Complete';
  public static readonly AdvisedStatusFF1Declined = 'FF1Declined';
  public static readonly AdvisedStatusFF1Incomplete = 'FF1Incomplete';
  public static readonly AdvisedStatusRecommendationMade = 'RecommendationMade';
  public static readonly AdvisedStatusWithAdvisor = 'WithAdvisor';
  public static readonly AmlSearchResultError = 'E';
  public static readonly AmlSearchResultNotPerformed = 'N';
  public static readonly AmlSearchResultSuccesful = 'S';
  public static readonly AnswerType = 'AnswerType';
  public static readonly AnswerTypeNo = 'N';
  public static readonly AnswerTypeYes = 'Y';
  public static readonly ApplicantAcceptanceStatus = 'ApplicantAcceptanceStatus';
  public static readonly ApplicantAcceptanceStatusAccepted = 'Accepted';
  public static readonly ApplicantAcceptanceStatusIssued = 'Issued';
  public static readonly ApplicantAcceptanceStatusViewed = 'Viewed';
  public static readonly ApplicantPriority = 'ApplicantPriority';
  public static readonly ApplicationTypeAip = 'Aip';
  public static readonly ApplicationTypeApplication = 'App';
  public static readonly ApplicationTypeDistributedDocument = 'DistributedDocument';
  public static readonly ApplicationTypeFactFind = 'FF';
  public static readonly ApplicationTypeKfi = 'Kfi';
  public static readonly ApplicationTypeName = 'ApplicationType';
  public static readonly AutoLinkUserToMortgageAccountStatusNotLinked = 'NotLinked';
  public static readonly ApplicationTypeRecommendation = 'Recommendation';
  public static readonly BusinessWriter = 'BW';
  public static readonly BuyToLetQuestions = 'DirectCustomerBuyToLetQuestions';
  public static readonly CallDirection = 'CallDirection';
  public static readonly CallDirectionInbound = 'Inbound';
  public static readonly CallDirectionOutbound = 'Outbound';
  public static readonly CallOutcome = 'CallOutcome';
  public static readonly CaseActivityTypeHumanDecision = 'HumanDecision';
  public static readonly CaseActivityTypeSystemDecision = 'SystemDecision';
  public static readonly CaseActivityTypeHumanStatusChange = 'HumanStatusChange';
  public static readonly CaseActivityTypeSystemStatusChange = 'SystemStatusChange';
  public static readonly CaseAdministrator = 'CA';
  public static readonly CaseAdministratorRight = 'CaseAdministratorRight';
  public static readonly CaseAdministratorRightFull = 'Full';
  public static readonly CaseHubSearchCaseTypes = 'CaseHubSearchCaseTypes';
  public static readonly CaseSearchSortOptions = 'CaseSearchSortOptions';
  public static readonly CaseStatus = 'CaseStatus';
  public static readonly CaseStatusAppWithUnderwriter = 'AppWithUnderwriter';
  public static readonly CaseStatusAppAcceptedPendingPayment = 'AppAcceptedPendingPayment';
  public static readonly CaseStatusKfiIssued = 'KFIIssued';
  public static readonly CaseStatusNotification = 'CaseStatusNotification';
  public static readonly CaseType = 'CaseType';
  public static readonly CaseTypeAdvisedOption = 'Advised';
  public static readonly CaseTypeCustomerMortgageAccountOption = 'CustomerMortgageAccount';
  public static readonly CaseTypeSwitch = 'Switch';
  public static readonly CaseTypeNewBusiness = 'NewBusiness';
  public static readonly CaseTypeNonAdvisedOption = 'NonAdvised';
  public static readonly CaseTypeSearch = 'CaseTypeSearch';
  public static readonly CaseTypeSwitchOption = 'Switch';
  public static readonly CaseTypeTaskHubSearch = 'TaskHubSearchCaseTypes';
  public static readonly ChangeSamIdAllowedStatuses = 'ChangeSamIdAllowedStatuses';
  public static readonly Country = 'Country';
  public static readonly CountryType = 'CountryType';
  public static readonly CountryTypeUk = 'UK';
  public static readonly CurrentMarginalTaxRateCode = 'CurrentMarginalTaxRate';
  public static readonly CustomerTypeOwnerMovingHouse = 'M';
  public static readonly CustomerTypePurchase = 'P';
  public static readonly CustomerTypePurchaseBTL = 'CustomerTypePurchaseBTL';
  public static readonly CustomerTypePurchaseResidential = 'CustomerTypePurchaseResidential';
  public static readonly CustomerTypeRemortgageBTL = 'CustomerTypeRemortgageBTL';
  public static readonly CustomerTypeRemortgageOnly = 'CustomerTypeRemortgageOnly';
  public static readonly CustomerTypeRemortgageResidential = 'CustomerTypeRemortgageResidential';
  public static readonly CustomerTypeRemortgaging = 'R';
  public static readonly DebtType = 'DebtType';
  public static readonly DebtTypeHpOrLease = 'L';
  public static readonly DebtTypeLoanOrStudentLoan = 'ReferenceValueToBeMappedForLoan';
  public static readonly DebtTypeMaintenance = 'MaintenanceCSAAndOrChildcareMonthlyPayments';
  public static readonly DebtTypeOther = 'O';
  public static readonly DebtTypeOverdraft = 'OD';
  public static readonly DebtTypeSchoolFees = 'SchoolFees';
  public static readonly DebtTypeStoreOrCreditCard = 'C';
  public static readonly DeedsLocation = 'DeedsLocation';
  public static readonly DefaultSearchCriteriaOption = 'CaseID';
  public static readonly DepositSourceType = 'DepositSourceType';
  public static readonly DepositSourceTypeAreDetailsRequired = 'AreDetailsRequired';
  public static readonly DirectCustomerResidentialStepOneQuestions = 'DirectCustomerResidentialStepOneQuestions';
  public static readonly DirectCustomerResidentialStepTwoQuestions = 'DirectCustomerResidentialStepTwoQuestions';
  public static readonly DirectProductPickerSortOptions = 'DirectProductPickerSortOptions';
  public static readonly DistributedDocumentDetails = 'DistributedDocumentDetails';
  public static readonly DistributedDocumentType = 'DistributedDocumentType';
  public static readonly DistributedDocumentTypeAllowExpireAttributeName = 'AllowExpire';
  public static readonly DropAdviceCategory = 'DropAdviceCategory';
  public static readonly EmploymentStatus = 'EmploymentStatus';
  public static readonly EmploymentStatusEmployed = 'E';
  public static readonly EmploymentStatusNotEmployed = 'U';
  public static readonly EmploymentStatusRetired = 'R';
  public static readonly EmploymentStatusSelfEmployed = 'S';
  public static readonly EmploymentType = 'EmploymentType';
  public static readonly EmploymentTypeAgencyWork = 'A';
  public static readonly EmploymentTypeContractor = 'C';
  public static readonly EmploymentTypeFixedTermContract = 'F';
  public static readonly EmploymentTypePermanent = 'P';
  public static readonly EmploymentTypeTemporaryContract = 'T';
  public static readonly ExecutionOnlyAipStatuses = 'ExecutionOnlyAipStatuses';
  public static readonly ExecutionOnlyAppStatuses = 'ExecutionOnlyAppStatuses';
  public static readonly ExecutionOnlyKfiStatuses = 'ExecutionOnlyKfiStatuses';
  public static readonly ExecutionOnlyMortgageOfferStatuses = 'ExecutionOnlyMortgageOfferStatuses';
  public static readonly ExecutionOnlySamStatuses = 'ExecutionOnlySamStatuses';
  public static readonly ExternalCaseSearchCriteria = 'ExternalCaseSearchCriteria';
  public static readonly FirmAuthorisationStatus = 'FirmAuthorisationStatus';
  public static readonly FirmAuthorisationStatusRegistered = 'Registered';
  public static readonly FirmTypeAppointedRepresentative = 'Registered';
  public static readonly FirmTypeDirectlyAuthorised = 'Authorised';
  public static readonly FirmTypeEeaAuthorised = 'EEA Authorised';
  public static readonly Gender = 'Gender';
  public static readonly IgnoredFilter = 'IgnoredFilter';
  public static readonly IllustrationStatus = 'IllustrationStatus';
  public static readonly IllustrationStatusCreated = 'Created';
  public static readonly IllustrationStatusReplaced = 'Replaced';
  public static readonly IllustrationStatusPublished = 'Published';
  public static readonly InstructSurveyContactTypeNotPrivateSale = 'InstructSurveyContactTypeNotPrivateSale';
  public static readonly InstructSurveyContactTypePrivateSale = 'InstructSurveyContactTypePrivateSale';
  public static readonly InternalAccountSearchCriteria = 'InternalAccountSearchCriteria';
  public static readonly InternalAccountSearchCriteriaAccountNumber = 'AccountNumber';
  public static readonly InternalCaseSearchCriteria = 'InternalCaseSearchCriteria';
  public static readonly InternalTaskSearchCriteria = 'InternalTaskSearchCriteria';
  public static readonly IsExclusiveProduct = 'IsExclusiveProduct';
  public static readonly KycStatus = 'KycStatus';
  public static readonly LengthOfUKResidency = 'LengthOfUKResidency';
  public static readonly LoanGroupType = 'LoanGroupType';
  public static readonly LoanGroupTypeBuyToLet = 'B';
  public static readonly LoanGroupTypeResidential = 'R';
  public static readonly LoginStatus = 'UserLoginStatus';
  public static readonly LoginStatusIncorrect = 'Incorrect';
  public static readonly LoginStatusIncomplete = 'Incomplete';
  public static readonly LoginStatusInvalid = 'Invalid';
  public static readonly MaritalStatus = 'MaritalStatus';
  public static readonly MortgageAccountText = 'MortgageAccountContextualMessageText';
  public static readonly MortgageAccountTextSwitchableWithPromoEndDateInFuture = 'SwitchableWithPromoEndDateInFuture';
  public static readonly MortgageAccountTextSubaccountWillBeSwitchableInFuture = 'SubaccountWillBeSwitchableInFuture';
  public static readonly MortgageAccountTextNotSwitchableWithPromoEndDateInFuture =
    'NotSwitchableWithPromoEndDateInFuture';
  public static readonly MortgageAccountTextSwitchableWithPromoEndDateInPast = 'SwitchableWithPromoEndDateInPast';
  public static readonly MortgageAccountTextNotSwitchableWithPromoEndDateInPast = 'NotSwitchableWithPromoEndDateInPast';
  public static readonly MortgageClub = 'MortgageClub';
  public static readonly MortgageClubOptionAll = 'All';
  public static readonly MortgageClubSelectionTypeCan = 'Can';
  public static readonly MortgageClubSelectionTypeMust = 'Must';
  public static readonly Nationality = 'Nationality';
  public static readonly NeedAdviceCallbackTime = 'NeedAdviceCallbackTime';
  public static readonly Occupation = 'Occupation';
  public static readonly OfferActivityType = 'OfferActivityTypes';
  public static readonly OfferAuditType = 'OfferAuditTypes';
  public static readonly OfferAuditTypeDDMAcceptancePdfGenerated = 'DDMAcceptancePdfGenerated';
  public static readonly OfferAuditTypeChannelChange = 'ChannelChange';
  public static readonly OfferCommunicationMethod = 'OfferCommunicationMethod';
  public static readonly OfferCommunicationMethodLetter = 'Letter';
  public static readonly OfferCommunicationMethodSMS = 'SMS';
  public static readonly OfferCommunicationMethodUnconfirmed = 'Unconfirmed';
  public static readonly OfferDistributionChannel = 'OfferDistributionChannel';
  public static readonly OfferDistributionChannelOnline = 'Online';
  public static readonly OfferDistributionChannelPostal = 'Postal';
  public static readonly OfferErrorReasonType = 'OfferErrorReasonType';
  public static readonly OnlineOfferActivityStatus = 'OnlineOfferActivityStatus';
  public static readonly OnlineOfferStatus = 'OnlineOfferStatus';
  public static readonly OnlineOfferStatusAccepted = 'Accepted';
  public static readonly OnlineOfferStatusCreated = 'Created';
  public static readonly OnlineOfferStatusError = 'Error';
  public static readonly OnlineOfferStatusExpired = 'Expired';
  public static readonly OnlineOfferStatusPublishingFailed = 'PublishingFailed';
  public static readonly OnlineOfferStatusHideOfferStatuses = [
    ReferenceDataOptionLists.OnlineOfferStatusCreated,
    ReferenceDataOptionLists.OnlineOfferStatusError,
    ReferenceDataOptionLists.OnlineOfferStatusPublishingFailed
  ];
  public static readonly OnlineOfferStatusPublished = 'Published';
  public static readonly OnlineOfferStatusSuperseded = 'Superseded';
  public static readonly OPFeeType = 'OPFeeType';
  public static readonly OPFeeTypeMakeMonthlyPayment = '1';
  public static readonly OPFeeTypeWarningMessageAttributeName = 'WarningMessage';
  public static readonly Owner = 'Owner';
  public static readonly PasswordStrengthLevel = 'PasswordStrengthLevel';
  public static readonly PaymentSearchSummary = 'PaymentSearchSummary';
  public static readonly PaymentStatus = 'PaymentStatus';
  public static readonly PaymentStatusCompleted = 'Completed';
  public static readonly PaymentStatusInProgress = 'InProgress';
  public static readonly PaymentStatusRefund = 'Refund';
  public static readonly PhoneNumberValidationStatus = 'PhoneNumberValidationStatus';
  public static readonly PhoneNumberValidationStatusAccepted = 'Accepted';
  public static readonly PhoneNumberValidationStatusDeclined = 'Declined';
  public static readonly PlaceholderHistoryChangeType = 'PlaceholderHistoryChangeType';
  public static readonly PlaceholderHistoryPriorityChange = 'PriorityChange';
  public static readonly PlaceholderHistoryStatusChange = 'StatusChange';
  public static readonly PlaceholderPriorities = 'PlaceholderPriorities';
  public static readonly PlaceholderPrioritiesAssessment = 'Assessment';
  public static readonly PlaceholderPrioritiesCompletion = 'Completion';
  public static readonly PlaceholderPrioritiesOffer = 'Offer';
  public static readonly PlaceholderStatus = 'PlaceholderStatus';
  public static readonly PlaceholderStatusCreated = 'Created';
  public static readonly PlaceholderStatusPublished = 'Published';
  public static readonly PlaceholderStatusRequested = 'Requested';
  public static readonly PlaceholderStatusUnable = 'UnableToSupply';
  public static readonly PlaceholderStatusClosed = 'Closed';
  public static readonly PlaceholderStatusInstructed = 'Instructed';
  public static readonly PlaceholderStatusAppointmentConfirmed = 'AppointmentConfirmed';
  public static readonly PlaceholderStatusReceived = 'Received';
  public static readonly PlaceholderStatusAccepted = 'Accepted';
  public static readonly PlaceholderStatusRejected = 'Rejected';
  public static readonly PlaceholderType = 'PlaceholderType';
  public static readonly PlaceholderTypeDocument = 'Document';
  public static readonly PlaceholderTypeInformationRequest = 'InformationRequest';
  public static readonly PlaceholderTypeSolicitor = 'Solicitor';
  public static readonly PlaceholderTypeThirdParty = 'ThirdParty';
  public static readonly PlaceholderTypeValuation = 'Valuation';
  public static readonly PlaceholderTypeOfferDistribution = 'OfferDistribution';
  public static readonly ProductPickerSortOptions = 'ProductPickerSortOptions';
  public static readonly ProductSelection = 'ProductSelection';
  public static readonly ProductSelectionByCode = 'ByCode';
  public static readonly ProductSelectionByType = 'ByType';
  public static readonly ProductStatus = 'ProductStatus';
  public static readonly PropertyConstructionPeriod = 'PropertyConstructionPeriod';
  public static readonly PropertyLocation = 'PropertyLocation';
  public static readonly PropertyLocationNone = 'None';
  public static readonly PropertyLocationNorthernIreland = 'I';
  public static readonly PropertyLocationScotland = 'Y';
  public static readonly PropertyType = 'PropertyType';
  public static readonly PropertyTypeConvertedFlat = 'C';
  public static readonly PropertyTypeConvertedStudioFlat = 'V';
  public static readonly PropertyTypePurposeBuiltFlat = 'P';
  public static readonly PropertyTypePurposeBuiltStudioFlat = 'F';
  public static readonly PropositionStatusCodeType = 'PropositionStatusCodeType';
  public static readonly PurchaseOrRemortgage = 'PurchaseOrRemortgage';
  public static readonly PurchaseOrRemortgagePurchase = 'Purchase';
  public static readonly PurchaseOrRemortgageRemortgage = 'Remortgage';
  public static readonly Range = 'Range';
  public static readonly RecommendationStatus = 'RecommendationStatus';
  public static readonly RecommendationStatusAdviceAccepted = 'AdviceAccepted';
  public static readonly RecommendationStatusAdviceExpired = 'AdviceExpired';
  public static readonly RecommendationStatusAdviceIncomplete = 'AdviceIncomplete';
  public static readonly RecommendationStatusAdviceIssued = 'AdviceIssued';
  public static readonly RecommendationStatusAdviceRejected = 'AdviceRejected';
  public static readonly RelationshipType = 'RelationshipType';
  public static readonly RelationshipTypeOther = 'Other';
  public static readonly RepaymentMethodBtl = 'RepaymentMethod';
  public static readonly RepaymentMethodBtlSaleOfThisProperty = 'SP';
  public static readonly RepaymentMethodResidential = 'RepaymentMethodResidential';
  public static readonly RepaymentType = 'RepaymentType';
  public static readonly RepaymentTypeFF = 'RepaymentTypeFF';
  public static readonly RepaymentTypeFFInterestOnly = 'Interest Only';
  public static readonly RepaymentTypeFFNotSure = 'NotSure';
  public static readonly RepaymentTypeFFPartAndPart = 'PartAndPart';
  public static readonly RepaymentTypeFFRepayment = 'Repayment';
  public static readonly RepaymentTypeHtb = 'RepaymentTypeHtb';
  public static readonly RepaymentTypeInterestOnly = 'Interest Only';
  public static readonly RepaymentTypePartAndPart = 'PartAndPart';
  public static readonly RepaymentTypeRepayment = 'Repayment';
  public static readonly RepaymentStrategy = 'RepaymentStrategy';
  public static readonly ResidentialStatus = 'ResidentialStatus';
  public static readonly ResidentialStatusOther = 'U';
  public static readonly ResidentialStatusOwn = 'O';
  public static readonly ResidentialStatusRentAuthority = 'RA';
  public static readonly ResidentialStatusRentPrivatly = 'RP';
  public static readonly RomeMortgageAccountStatus = 'RomeMortgageAccountStatus';
  public static readonly SAMAccountType = 'SAMAccountType';
  public static readonly SamClass = 'SamClass';
  public static readonly SamClassExcludedForTermChange = 'SamClassExcludedForTermChange';
  public static readonly SamDownloadStatus = 'SamDownloadStatus';
  public static readonly SamDownloadStatusError = 'E';
  public static readonly ScorebandOptions = 'ScorebandOptions';
  public static readonly SecurityQuestion = 'SecurityQuestion';
  public static readonly SelectionTypeAdvised = 'AI';
  public static readonly SelectionTypeBtl = 'SelectionTypeBtl';
  public static readonly SelectionTypeNonAdvised = 'EX';
  public static readonly SelectionTypeResidential = 'SelectionTypeResidential';
  public static readonly ServiceLevel = 'ServiceLevel';
  public static readonly SourceOfWealth = 'SourceOfWealth';
  public static readonly SponsorRepaymentType = 'SponsorRepaymentType';
  public static readonly SponsorRepaymentTypeInterestOnly = 'I';
  public static readonly StaffTeams = 'Team';
  public static readonly SuitabilityReportStatusNotification = 'SuitabilityReportStatusNotification';
  public static readonly SwitchCaseType = 'Switch';
  public static readonly SwitchCaseStatus = 'SwitchCaseStatus';
  public static readonly SwitchCaseStatusIllustrationIssued = 'IllustrationIssued';
  public static readonly SwitchCaseStatusIllustrationRequested = 'IllustrationRequested';
  public static readonly SwitchCaseStatusInProgress = 'InProgress';
  public static readonly SwitchCaseStatusSwitchCompleted = 'SwitchCompleted';
  public static readonly SwitchCaseStatusSwitchConfirmed = 'SwitchConfirmed';
  public static readonly SwitchCaseStatusSwitchNotProceeding = 'SwitchNotProceeding';
  public static readonly SwitchCaseStatusSwitchRequested = 'SwitchRequested';
  public static readonly SwitchRequestType = 'SwitchRequestType';
  public static readonly SwitchRequestTypeEsis = 'ESIS';
  public static readonly SwitchRequestTypeVomo = 'VOMO';
  public static readonly TaskHistoryChangeType = 'TaskHistoryChangeType';
  public static readonly TaskHistoryChangeTypeAllocationChange = 'AllocationChange';
  public static readonly TaskHistoryChangeTypeStatusChange = 'StatusChange';
  public static readonly TaskSearchSortOptions = 'TaskSearchSortOptions';
  public static readonly TaskStatus = 'TaskStatus';
  public static readonly TaskStatusClosed = 'Closed';
  public static readonly TaskStatusCompleted = 'Completed';
  public static readonly TaskStatusCreated = 'Created';
  public static readonly TaskStatusInProgress = 'InProgress';
  public static readonly TaskStatusOptions = 'TaskStatusOptions';
  public static readonly TaskStatusPublished = 'Published';
  public static readonly Team = 'Team';
  public static readonly TenureType = 'TenureType';
  public static readonly TenureTypeFreehold = 'F';
  public static readonly TenureTypeLeasehold = 'L';
  public static readonly TermChangeType = 'TermChangeType';
  public static readonly TermChangeTypeReduce = 'Reduce';
  public static readonly TermChangeTypeExtend = 'Extend';
  public static readonly TermExtensionReason = 'TermExtensionReason';
  public static readonly Title = 'Title';
  public static readonly TransactHighPolicyRule = 'TransactHighPolicyRule';
  public static readonly TransactHighPolicyRules = 'TransactHighPolicyRule';
  public static readonly TransactStatusCodes = 'TransactStatusCodes';
  public static readonly TransactionCaseTypes = 'TransactionCaseTypes';
  public static readonly TransactionStatusMarkFeesAsPaidByUnderwriter = 'U';
  public static readonly TransactionStatusPaymentSuccesful = 'Y';
  public static readonly TransactionStatusPendingTransaction = 'P';
  public static readonly TransactionStatusRefundIncomplete = '-1';
  public static readonly TransactionStatusRefundUnauthorized = 'N';
  public static readonly UserRegistrationStatus = 'UserRegistrationStatus';
  public static readonly UserRegistrationStatusAlreadyRegistered = 'AlreadyRegistered';
  public static readonly UserRegistrationStatusSuccessful = 'Successful';
  public static readonly UserRegistrationStatusUserChangeIncomplete = 'UserChangeIncomplete';
  public static readonly UserRegistrationStatusInvalid = 'Invalid';
  public static readonly ValabilityStatus = 'ValabilityStatusPermanent';
  public static readonly ValabilityStatusOptionTemporary = 'Temporary';
  public static readonly ValabilityStatusTemporary = 'ValabilityStatusTemporary';
  public static readonly ValuationReportPayerType = 'ValuationReportPayerType';
  public static readonly ValuationReportPayerTypeApplicant = 'Applicant';
  public static readonly ValuationReportPayerTypeVendor = 'Vendor';
  public static readonly ValuationReportType = 'ValuationReportType';
  public static readonly ValuationReportTypeBuildingSurvey = 'buildingStructuralSurvey';
  public static readonly ValuationReportTypeHomeBuyers = 'homeBuyersReport';
  public static readonly ValuationReportTypeMortgageValuation = 'mortgageValuationReport';
  public static readonly VomoIssueType = 'VomoIssueType';
  public static readonly VomoIssueTypeByEmail = 'ByEmail';
  public static readonly WhenToPayFee = 'WhenToPayFee';
  public static readonly WhenToPayFeeCompletion = 'Completion';
  public static readonly WhenToPayFeeMortgage = 'Mortgage';
  public static readonly WhenToSwitch = 'WhenToSwitch';
  public static readonly WhenToSwitchEndOfDate = 'EndOfDate';
  public static readonly WhenToSwitchNow = 'Now';
  public static readonly WhereDidUserHearAboutProduct = 'WhereDidUserHearAboutProduct';
  public static readonly WorldPayTransactionStatus = 'WorldPayTransactionStatus';
  public static readonly WorldPayTransactionStatusPendingPayment = 'P';
}
